// wave4-nav-ia: "Recent" sidebar section -- last ~5 viewed TeeUps, client-side only per QJ's
// approved nav IA (WEB-FIX-BATCH-1-2026-07-02.md item 3). localStorage-backed, keyed per user so
// personas/accounts on the same browser don't bleed into each other. Dispatches a window event on
// write so the sidebar re-renders live without Redux plumbing.

const KEY_PREFIX = "coowe.recentTeeups."
const MAX_RECENT = 5
export const RECENT_TEEUPS_EVENT = "coowe:recent-teeups-changed"

const keyFor = userId => `${KEY_PREFIX}${userId || "anon"}`

export const getRecentTeeups = userId => {
  try {
    const raw = window.localStorage.getItem(keyFor(userId))
    const arr = raw ? JSON.parse(raw) : []
    return Array.isArray(arr) ? arr.slice(0, MAX_RECENT) : []
  } catch (e) {
    return []
  }
}

export const recordRecentTeeup = (userId, teeup) => {
  if (!teeup || teeup.id == null || !teeup.name) return
  try {
    const list = getRecentTeeups(userId).filter(t => t.id !== teeup.id)
    list.unshift({ id: teeup.id, name: String(teeup.name).slice(0, 80), ts: Date.now() })
    window.localStorage.setItem(keyFor(userId), JSON.stringify(list.slice(0, MAX_RECENT)))
    window.dispatchEvent(new Event(RECENT_TEEUPS_EVENT))
  } catch (e) {
    // best-effort -- never break the TeeUp page over a recents write
  }
}
